import {
  CountryCode,
  HumanNamePrefix,
  PersonIdentityCode,
} from '@quromedical/fhir-common';
import type { Person as FhirPerson } from 'fhir/r4';
import { z } from 'zod';

export type PersonGender = NonNullable<FhirPerson['gender']>;

export const GenderSchema = z.union([
  z.literal('unknown'),
  z.literal('male'),
  z.literal('female'),
  z.literal('other'),
]);

export const CoordinatesSchema = z.object({
  latitude: z.number(),
  longitude: z.number(),
});

export const GeneralSchema = z.object({
  prefixName: z.nativeEnum(HumanNamePrefix),
  givenName: z.string(),
  familyName: z.string(),
  gender: GenderSchema,
  birthDate: z.string(),
  identifierCode: z.nativeEnum(PersonIdentityCode),
  identifierValue: z.string(),
});

export const GeneralUpdateSchema = z.object({
  id: z.string().uuid(),
  general: GeneralSchema,
});

export const ContactSchema = z.object({
  /**
   * In formik you can reference this as `phoneNumbers.0` and `phoneNumbers.1` to populate array
   * values if there isn't an appropriate multi-text input
   */
  telecomPhoneNumbers: z.array(z.string()),
  telecomEmail: z.string(),
  /**
   * Google address place_Id is from google place autocomplete
   */
  addressPlaceId: z.string().optional(),
  addressCoordinates: CoordinatesSchema.optional(),
  addressLines: z.array(z.string()),
  addressCity: z.string(),
  addressCountry: z.nativeEnum(CountryCode),
  addressPostalCode: z.string(),
});

export type PersonContact = z.infer<typeof ContactSchema>;

export type PersonGeneral = z.infer<typeof GeneralSchema>;
